import { getEmbedInfo, PLATFORM_LABEL } from "@/lib/embeds";
import { ExternalLink, Instagram, Music2, Youtube } from "lucide-react";

const ICON = { instagram: Instagram, tiktok: Music2, youtube: Youtube };

export default function EmbedCard({ work }) {
  const info = getEmbedInfo(work.url);
  const Icon = ICON[work.platform] || ExternalLink;

  return (
    <div className="border border-border rounded-sm overflow-hidden bg-background hover:border-primary transition-colors group" data-testid={`work-${work.id}`}>
      <div className={`relative bg-secondary ${info?.platform === "tiktok" ? "aspect-[9/16]" : info?.platform === "youtube" ? "aspect-video" : "aspect-square"}`}>
        {info ? (
          <iframe
            src={info.embedUrl}
            title={work.title || work.url}
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            scrolling="no"
            frameBorder="0"
            className="absolute inset-0 w-full h-full"
          />
        ) : (
          <a href={work.url} target="_blank" rel="noreferrer" className="absolute inset-0 flex flex-col items-center justify-center text-muted-foreground gap-2">
            <ExternalLink className="w-8 h-8" />
            <span className="text-xs">Abrir publicación</span>
          </a>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-center justify-between mb-2 text-[10px] uppercase tracking-widest font-bold">
          <span className="inline-flex items-center gap-1 text-muted-foreground">
            <Icon className="w-3 h-3" /> {PLATFORM_LABEL[work.platform] || work.platform}
          </span>
          <span className="text-primary">{work.category}</span>
        </div>
        {work.title && <h4 className="font-semibold text-sm mb-1 line-clamp-2">{work.title}</h4>}
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          {work.brand && <span className="font-semibold text-foreground truncate">{work.brand}</span>}
          {work.date && <span>{work.date}</span>}
        </div>
      </div>
    </div>
  );
}
